'use client';

import { useRouter } from "next/router";
import React from "react";
import FormattedMessage from "./FormattedMessage";
import HelpButton from "./HelpButton";
import { useUserAgentContext } from "./UserAgentContext";



export default function HelpPage() {

    const platform = useUserAgentContext();
    const router = useRouter();

    return (
        <div className="text-container">
            <img className="content-image" src="/images/ill_kpk-warning_160.svg" alt="Kodak Alaris Kiosk" />
            <br />
            <div className="content-text">
                <FormattedMessage id="trouble-connecting" classoverride="title" />
                <br />
                <FormattedMessage id={platform === "ios" ? "ios-try-airprint" : "see-our-help-topics"} classoverride="label" />
                <br />
                <br />
            </div>
            

            { platform === "ios" && 
                <>
                    <div className="buttons-container">
                        <HelpButton messageId="ios-airprint-title" iconSrc="/images/icon_airprint.svg" recommended onClick={() => router.push('/help/airprint')}/>
                    </div>
                    <div className="content-text-left content-text-pb">
                        <FormattedMessage id="more-help-options" />
                    </div>
                </>
            }
            <div className="buttons-container">
                { platform === 'ios' && <HelpButton messageId="ios-pause-private-relay-or-browsing" iconSrc="/images/icon_private-relay.svg" onClick={() => router.push('/help/private-relay-browsing')} /> }
                <HelpButton messageId="deactivate-vpn" iconSrc={platform === 'ios' ? "/images/icon_vpn-ios.svg" : "/images/icon_vpn-android.svg"} onClick={() => router.push('/help/vpn')}/>
                <HelpButton messageId="reconnect-to-wifi" iconSrc="/images/icon_wifi.svg" onClick={() => router.push('/help/wifi')}/>
            </div>
        </div>
    );
};